import { render, staticRenderFns } from "./my-index.vue?vue&type=template&id=50996101&scoped=true&"
import script from "./my-index.vue?vue&type=script&lang=js&"
export * from "./my-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50996101",
  null
  
)

export default component.exports